import React from "react";
import OrderForm from "../components/OrderForm";

export default function Form({ isVisible }) {
  return (
    <div className={isVisible ? "" : "not-visible"}>
      <p className="tel-pt-view-description">Ange din information nedan och klicka på 'Skicka'. Vi tar hand om resten!</p>
      <OrderForm isNaForm={false} />
    </div>
  );
}
